import { UploadInput } from '@nexelem/inputs';
import { FieldValues, useController, UseControllerProps } from 'react-hook-form';
import { MaxWidthProp, maxWidthVariants } from '../utils/maxWidthVariants';
import { cn } from '@nexelem/utils';

type UploadFileFormInputProps<Value extends FieldValues> = Omit<UseControllerProps<Value>, 'disabled'> & {
  required?: boolean;
  label?: string;
  placeholder?: string;
  size?: 'medium' | 'large' | 'jumbo';
  fileName?: string;
  maxWidth?: MaxWidthProp;
  showErrorMessage?: boolean;
  className?: string;
};

export const FormUploadFileInput = <Value extends FieldValues>({
  required,
  label,
  placeholder,
  size,
  fileName,
  showErrorMessage = true,
  maxWidth = 560,
  className,
  ...props
}: UploadFileFormInputProps<Value>) => {
  const { field, fieldState } = useController(props);
  const errorMessage = showErrorMessage ? fieldState.error?.message : undefined;

  return (
    <div className={cn(maxWidthVariants({ maxWidth }), className)}>
      <UploadInput
        {...field}
        {...props}
        error={!!fieldState.error}
        errorMessage={errorMessage}
        fileName={fileName}
        label={label}
        placeholder={placeholder}
        required={required}
        size={size}
        onChange={(e) => field.onChange(e)}
      />
    </div>
  );
};
